import styled from 'styled-components';
import { TextField } from '@material-ui/core';

export const UITextFieldFullWidth = styled(TextField)`
  width: 100% !important;
`;

export default UITextFieldFullWidth;
